import React from "react";

export default function PrivacyPolicy() {
    return (
        <div style={{ height: "100vh" }}>
            <iframe
                src="/docs/privacy_policy.pdf"
                title="Политика конфиденциальности"
                width="100%"
                height="100%"
                style={{ border: "none" }}
            />
        </div>
    );
}
